import clsx from "clsx";
import style from "./PropertyDetails.module.css";
import { RootState } from "@/store/dtm";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { applicationCategory } from "@/types/applicationType";
import { selectPropertyInfo, setClosingDate, setFinancingConditionExists, setFinancingConditionDate, setFundingDate, setHeatingCost, setLivableArea, setLivableAreaUnit, setMaintenanceFee, setMonthlyRent, setNumOfRentalProperties, setNumOfRentalUnits, setOwnOtherRentalProperties, setPropertyTax, setPropertyValue, setPurchasePrice, setPurposeOfProperty, setRentOut, setSeparateUnit, setHeatingType, setMortgageBalance, setOriginalPurchasePrice, setMortgageHolder, setSubjectPropertyRentalUnits, setOwnershipPercentage } from "@/slices/propertyInfoSlice";
import CurrencyInput from "react-currency-input-field";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { selectPropertyAddress, setPACity, setPACountry, setPAPostalCode, setPAProvince, setPAStreetDirection, setPAStreetName, setPAStreetNumber, setPAStreetType, setPAUnitNumber, setPAUnitType } from "@/slices/propertyAddressSlice";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PropertyForCreationDto, SubjectPropertyDto, AddressDto } from "@/lib/DTMWebAPIClient.generated";
import { createApiClient } from "@/lib/Requests";
import { addBusinessDays, displayDateString, streetTypeList } from "@/lib/util";
import { streetDirections } from "@/ts/streetDirections";
import { streetTypes } from "@/ts/streetTypes";
import { AnimatePresence, motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function PropertyDetails(props: any) {
    const navigate = useNavigate();
    const getStreetTypes = streetTypeList();
    const application = useSelector(
        (state: RootState) => state.application.application
    );
    const applicant = useSelector(
        (state: RootState) => state.applicant.applicant
    );
    const propertyInfo = useSelector(selectPropertyInfo).propertyInfo;
    const propertyAddress = useSelector(selectPropertyAddress).address;
    const credential = useSelector(
        (state: RootState) => state.credential
    );
    const assets = useSelector((state: RootState) => state.assets.assets);
    const client = createApiClient({ timeout: 60000, token: credential.credential.accessToken });
    const dispatch = useDispatch();
    const [showEdit, setShowEdit] = useState(false);
    const [showPropertyAddress, setShowPropertyAddress] = useState(false);
    const [purchasePriceAmount, setPurchasePriceAmount] = useState("");
    const [newPurchasePriceAmount, setNewPurchasePriceAmount] = useState("");

    const [originalPriceAmount, setOriginalPriceAmount] = useState("");
    const [newOriginalPriceAmount, setNewOriginalPriceAmount] = useState("");

    const [currentValueAmount, setCurrentValueAmount] = useState("");
    const [newCurrentValueAmount, setNewCurrentValueAmount] = useState("");

    const [remainingBalanceAmount, setRemainingBalanceAmount] = useState("");
    const [newRemainingBalanceAmount, setNewRemainingBalanceAmount] = useState("");

    const [propertyTaxAmount, setPropertyTaxAmount] = useState("");
    const [newPropertyTaxAmount, setNewPropertyTaxAmount] = useState("");

    const [heatingCostAmount, setHeatingCostAmount] = useState("");
    const [newHeatingCostAmount, setNewHeatingCostAmount] = useState("");
    const [maintenanceFeeAmount, setMaintenanceFeeAmount] = useState("");
    const [newMaintenancFeeAmount, setNewMaintenanceFeeAmount] = useState("");
    const [rentAmount, setRentAmount] = useState("");

    const [occupancy, setOccupancy] = useState("");
    const [partiallyRented, setPartiallyRented] = useState("no");
    const [separateUnitExists, setSeparateUnitExists] = useState("no");
    const [monthlyRentAmount, setMonthlyRentAmount] = useState("");
    const [ownRentalProperties, setOwnRentalProperties] = useState("no");
    const [displayPropertyAddressError, setDisplayPropertyAddressError] = useState(false);

    const [closingDateText, setClosingDateText] = useState(dayjs);
    const [fundingDateText, setFundingDateText] = useState(dayjs);
    const [displayError, setDisplayError] = useState(false);

    const [includeFinancingCondition, setIncludeFinancingCondition] = useState("");
    const [financingConditionDateText, setFinancingConditionDateText] = useState(dayjs);
    const [displayFinancingDateError, setDisplayFinancingDateError] = useState(false);

    const [fundingDateDisplayText, setFundingDateDisplayText] = useState("");
    const [closingDateDisplayText, setClosingDateDisplayText] = useState("");
    const [financingConditionDisplayText, setFinancingConditionDisplayText] = useState("");

    const [originalPurchaseDateText, setOriginalPurchaseDateText] = useState("");
    const [futureUsageText, setFutureUsageText] = useState("");
    const [propertySoldText, setPropertySoldText] = useState("");
    const [saleDateText, setSaleDateText] = useState("");
    const [propertyTypeText, setPropertyTypeText] = useState("");

    const [isSaving, setIsSaving] = useState(false);

    const openEdit = () => {
        setShowEdit(true);

        methods.setValue(
            "autoPaAddress",
            (propertyAddress.unitNumber ? propertyAddress.unitNumber + "-" : "") +
            propertyAddress.streetNumber +
            " " +
            propertyAddress.streetName +
            " " +
            propertyAddress.streetType +
            ", " +
            propertyAddress.city +
            ", " +
            propertyAddress.province.slice(0, 2).toUpperCase() +
            " " +
            propertyAddress.postalCode
        );
        methods.setValue("paStreetNumber", propertyAddress.streetNumber);
        methods.setValue("paStreetName", propertyAddress.streetName);
        methods.setValue("paStreetType", propertyAddress.streetType);
        methods.setValue("paStreetDirection", propertyAddress.streetDirection);
        methods.setValue("paUnitNumber", propertyAddress.unitNumber);
        methods.setValue("paUnitType", propertyAddress.unitType);
        methods.setValue("paCityName", propertyAddress.city);
        methods.setValue("paProvinceName", propertyAddress.province);
        methods.setValue("paPostalCode", propertyAddress.postalCode);
        methods.setValue("paCountry", propertyAddress.country);

        props.editModeOn(!showEdit);

        const formattedPurchasePrice = propertyInfo.purchasePrice.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        methods.setValue("purchasePrice", propertyInfo ? propertyInfo.purchasePrice == 0 ? "" : formattedPurchasePrice : "");
        setNewPurchasePriceAmount(propertyInfo ? propertyInfo.purchasePrice == 0 ? "" : propertyInfo.purchasePrice.toString() : "");

        const formattedPropertyValue = propertyInfo.propertyValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        methods.setValue("currentPropertyValue", propertyInfo ? propertyInfo.propertyValue == 0 ? "" : formattedPropertyValue : "");
        setNewCurrentValueAmount(propertyInfo ? propertyInfo.propertyValue == 0 ? "" : propertyInfo.propertyValue.toString() : "");

        const formattedOriginalPrice = propertyInfo.originalPurchasePrice.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        methods.setValue("originalPurchasePrice", propertyInfo ? propertyInfo.originalPurchasePrice == 0 ? "" : formattedOriginalPrice : "");
        setNewOriginalPriceAmount(propertyInfo ? propertyInfo.originalPurchasePrice == 0 ? "" : propertyInfo.originalPurchasePrice.toString() : "");

        const formattedBalance = propertyInfo.mortgageBalance.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        methods.setValue("remainingBalance", propertyInfo ? propertyInfo.propertyValue == 0 ? "" : formattedBalance : "");
        setNewRemainingBalanceAmount(propertyInfo ? propertyInfo.mortgageBalance == 0 ? "" : propertyInfo.mortgageBalance.toString() : "");

        const formattedPropertyTax = propertyInfo.propertyTax.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        methods.setValue("propertyTax", propertyInfo ? propertyInfo.propertyTax == 0 ? "" : formattedPropertyTax : "");
        setNewPropertyTaxAmount(propertyInfo ? propertyInfo.propertyTax == 0 ? "" : propertyInfo.propertyTax.toString() : "");

        const formattedHeatingCost = propertyInfo.heatingCost.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        methods.setValue("heatingCost", propertyInfo ? propertyInfo.heatingCost == 0 ? "" : formattedHeatingCost : "");
        setNewHeatingCostAmount(propertyInfo ? propertyInfo.heatingCost == 0 ? "" : propertyInfo.heatingCost.toString() : "");

        const formattedMaintenanceFee = propertyInfo.maintenanceFee.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        methods.setValue("maintenanceFee", propertyInfo ? propertyInfo.maintenanceFee == 0 ? "" : formattedMaintenanceFee : "");
        setNewMaintenanceFeeAmount(propertyInfo ? propertyInfo.maintenanceFee == 0 ? "" : propertyInfo.maintenanceFee.toString() : "");

        methods.setValue("heatingType", propertyInfo ? propertyInfo.heatingType : "");
        methods.setValue("livableArea", propertyInfo ? propertyInfo.livableArea.toString() : "");
        methods.setValue("livableAreaUnit", propertyInfo.livableAreaUnit);
        methods.setValue("occupancy", propertyInfo ? propertyInfo.purposeOfProperty : "");
        methods.setValue("mortgageHolder", propertyInfo?.mortgageHolder);
        setOccupancy(propertyInfo ? propertyInfo.purposeOfProperty : "");
        methods.setValue("partiallyRented", propertyInfo.rentOut ? "yes" : "no");
        setPartiallyRented(propertyInfo.rentOut ? "yes" : "no");
        setSeparateUnitExists(propertyInfo.separateUnit ? "yes" : "no");
        methods.setValue("separateUnit", propertyInfo.separateUnit ? true : false);

        const formattedRent = propertyInfo.monthlyRent.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        methods.setValue("monthlyRent", propertyInfo ? propertyInfo.monthlyRent == 0 ? "" : formattedRent : "");
        setMonthlyRentAmount(propertyInfo ? propertyInfo.monthlyRent == 0 ? "" : propertyInfo.monthlyRent.toString() : "");

        setOwnRentalProperties(propertyInfo.ownOtherRentalProperties ? "yes" : "no");
        methods.setValue("subjectPropertyRentalUnitCount", propertyInfo.subjectPropertyRentalUnits ? propertyInfo.subjectPropertyRentalUnits.toString() : "");
        methods.setValue("rentalPropertyCount", propertyInfo.numOfRentalProperties ? propertyInfo.numOfRentalProperties.toString() : "");
        methods.setValue("rentalUnitCount", propertyInfo.numOfRentalUnits ? propertyInfo.numOfRentalUnits.toString() : "");

        if (propertyInfo.purposeOfProperty === "I'll rent it out") {
            methods.setValue("ownershipPercentage", propertyInfo.ownershipPercentage == undefined ? "" : propertyInfo.ownershipPercentage.toString());
        }

        methods.setValue("closingDate", propertyInfo ? propertyInfo.closingDate : "");
        methods.setValue("fundingDate", propertyInfo ? propertyInfo.fundingDate : "");
        if (application.applicationCategory == applicationCategory.Buy) {
            let dateComponents = propertyInfo?.closingDate.split("/");
            let date = dayjs(dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0]);
            setClosingDateText(date);
            setClosingDateDisplayText(displayDateString(date));
        } else {
            let dateComponents = propertyInfo?.fundingDate.split("/");
            let date = dayjs(dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0]);
            setFundingDateText(date);
            setFundingDateDisplayText(displayDateString(date));
        }
        methods.setValue("financingConditionExists", propertyInfo.financingConditionExists ? "yes" : "no");
        setIncludeFinancingCondition(propertyInfo.financingConditionExists);
        methods.setValue("financingConditionDate", propertyInfo.financingConditionDate);
        if (propertyInfo?.financingConditionDate != undefined) {
            let dateComponents = propertyInfo?.financingConditionDate.split("/");
            let date = dayjs(dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0]);
            setFinancingConditionDateText(date);
            setFinancingConditionDisplayText(displayDateString(date));
        }
    };

    const closeEdit = () => {
        setShowEdit(false);
        methods.clearErrors();
        props.editModeOn(!showEdit);
    };

    const fields = [
        {
            element: "property-search",
            field: "",
            mode: window.pca?.fieldMode.SEARCH,
        },

        {
            element: "property-span-street-address",
            field: "Line1",
            mode: window.pca?.fieldMode.POPULATE,
        },
        {
            element: "property-span-street-address2",
            field: "Line2",
            mode: window.pca?.fieldMode?.POPULATE,
        },
        { element: "city", field: "City", mode: window.pca?.fieldMode.POPULATE },
        {
            element: "property-span-state",
            field: "ProvinceCode",
            mode: window.pca?.fieldMode.POPULATE,
        },
        {
            element: "property-span-postcode",
            field: "PostalCode",
            mode: window.pca?.fieldMode.POPULATE,
        },
        {
            element: "property-span-country",
            field: "CountryName",
            mode: window.pca?.fieldMode.POPULATE,
        },
    ];
    const options = {
        key: "XD95-YY77-BP99-EM55",
    };

    const control = new window.pca.Address(fields, options);

    const handlePropertyChange = (ev: any) => {
        setShowPropertyAddress(true);
        // checks for selecting an item from cp results
        try {
            if (ev.srcElement.parentElement.className.includes("pca")) {
                setTimeout(formatAddress, 500);
            }
        } catch (e) { }
    };

    const formatAddress = () => {
        const span = document.getElementById("property-span-street-address");
        const span2 = document.getElementById("property-span-city");
        const span3 = document.getElementById("property-span-state");
        const span4 = document.getElementById("property-span-postcode");
        const span5 = document.getElementById("property-span-country");

        if (!span || !span2 || !span3 || !span4 || !span5) return;

        const streetAddress = span!.innerHTML?.split(" ");
        const streetNumber = streetAddress?.shift();
        const streetInfo = streetAddress?.join(" ");
        let streetName = "";
        let streetDirection = "";
        let streetType = "";
        let streetComponents: string[] = streetInfo.split(" ");
        let lastStreetComponent = streetComponents[streetComponents.length - 1].toUpperCase();

        //Check if street direction and type exists in the street name
        if (streetDirections.includes(lastStreetComponent)) {
            streetDirection = lastStreetComponent;
            let secondLastStreetComponent = streetComponents[streetComponents.length - 2].toUpperCase();
            if (streetTypes.includes(secondLastStreetComponent)) {
                streetType = secondLastStreetComponent;
            }
            streetComponents.forEach((value, index) => {
                if (index < streetComponents.length - 2) {
                    streetName += value + " "
                }
            });
        } else if (streetTypes.includes(lastStreetComponent)) {
            streetType = lastStreetComponent;
            streetComponents.forEach((value, index) => {
                if (index != streetComponents.length - 1) {
                    streetName += value + " "
                }
            });
        } else {
            streetComponents.forEach((value, index) => {
                streetName += value + " "
            });
        }
        streetName = streetName.trim();

        methods.setValue("autoPaAddress", span!.innerHTML);
        methods.setValue("paCityName", span2!.innerHTML);
        methods.setValue("paProvinceName", span3!.innerHTML);
        methods.setValue("paPostalCode", span4!.innerHTML);
        methods.setValue("paCountry", span5!.innerHTML);
        methods.setValue("paStreetName", streetName);
        methods.setValue("paStreetType", streetType);
        methods.setValue("paStreetNumber", streetNumber!);
        methods.setValue("paStreetDirection", streetDirection);

        //Parse Unit Number (if it exists)
        if (streetNumber?.includes("-")) {
            const unit = streetNumber.split("-")[0];
            const number = streetNumber.split("-")[1];
            methods.setValue("paUnitNumber", unit!);
            methods.setValue("paStreetNumber", number!);
        } else {
            methods.setValue("paUnitNumber", "");
            methods.setValue("paStreetNumber", streetNumber!);
        }

        if (span3!.innerHTML?.trim().toLowerCase() != "on") {
            setDisplayPropertyAddressError(true);
        } else {
            setDisplayPropertyAddressError(false);
        }
    };

    const onSubmit = async (data: any) => {
        if (displayPropertyAddressError) return;

        if (data.paStreetType.trim() == "") {
            methods.setError("paStreetType", {
                type: "required",
                message: "Select your street type",
            });
            return;
        }

        //Save Property Address
        dispatch(setPAStreetNumber(methods.getValues("paStreetNumber")));
        dispatch(setPAStreetName(methods.getValues("paStreetName")));
        dispatch(setPAStreetType(methods.getValues("paStreetType")));
        dispatch(setPAStreetDirection(methods.getValues("paStreetDirection")));
        dispatch(setPAUnitNumber(methods.getValues("paUnitNumber")));
        dispatch(setPAUnitType(methods.getValues("paUnitType")));
        dispatch(setPACity(methods.getValues("paCityName")));
        dispatch(setPAProvince(methods.getValues("paProvinceName")));
        dispatch(setPAPostalCode(methods.getValues("paPostalCode")));
        dispatch(setPACountry(methods.getValues("paCountry")));

        let closingDate = undefined;
        let fundingDate = undefined;
        let conditionOfFinancingDate = undefined;
        if (application.applicationCategory == applicationCategory.Buy) {
            let dateComponents = data.closingDate.split("/");
            closingDate = dayjs(dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0]);
            let maxDate = dayjs('2069-12-31');
            if (data.closingDate == "Invalid Date" || closingDate > maxDate || closingDate < addBusinessDays(9)) {
                setDisplayError(true);
                return;
            }
            setDisplayError(false);
            dispatch(setClosingDate(data.closingDate));
        } else {
            let dateComponents = data.fundingDate.split("/");
            fundingDate = dayjs(dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0]);
            let maxDate = dayjs('2069-12-31');
            if (data.fundingDate == "Invalid Date" || fundingDate > maxDate || fundingDate < addBusinessDays(9)) {
                setDisplayError(true);
                return;
            }
            setDisplayError(false);
            dispatch(setFundingDate(data.fundingDate));
        }
        setPurchasePriceAmount(data.purchasePrice);
        dispatch(setPurchasePrice(+newPurchasePriceAmount));
        setCurrentValueAmount(data.currentPropertyValue);
        dispatch(setPropertyValue(+newCurrentValueAmount));
        setOriginalPriceAmount(data.originalPurchasePrice);
        dispatch(setOriginalPurchasePrice(+newOriginalPriceAmount));
        dispatch(setMortgageHolder(data.mortgageHolder));

        const formattedPropertyTax = (+newPropertyTaxAmount).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setPropertyTaxAmount(formattedPropertyTax);

        dispatch(setPropertyTax(+newPropertyTaxAmount));

        const formattedHeatingCost = (+newHeatingCostAmount).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setHeatingCostAmount(formattedHeatingCost);

        setMaintenanceFeeAmount(data.maintenanceFee);
        dispatch(setLivableArea(+data.livableArea));
        dispatch(setLivableAreaUnit(data.livableAreaUnit));
        dispatch(setHeatingCost(+newHeatingCostAmount));
        dispatch(setHeatingType(data.heatingType));
        dispatch(setMaintenanceFee(+newMaintenancFeeAmount));
        dispatch(setPurposeOfProperty(data.occupancy));
        dispatch(setRentOut(data.partiallyRented === "yes" ? true : false));
        dispatch(setSeparateUnit(data.separateUnit === "yes" ? true : false));
        dispatch(setMonthlyRent(((data.partiallyRented === "no" || data.separateUnit === "no") && data.occupancy != "I'll rent it out") ? 0 : +monthlyRentAmount));
        dispatch(setOwnOtherRentalProperties(data.ownRentalProperties === "yes" ? true : false));
        dispatch(setSubjectPropertyRentalUnits((+methods.getValues("subjectPropertyRentalUnitCount"))));
        dispatch(setNumOfRentalProperties(+methods.getValues("rentalPropertyCount")));
        dispatch(setNumOfRentalUnits(+methods.getValues("rentalUnitCount")));
        dispatch(setOwnershipPercentage(data.occupancy === "I'll rent it out" ? +methods.getValues("ownershipPercentage") : undefined));

        const formattedRent = (+monthlyRentAmount).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setRentAmount(formattedRent);

        if (includeFinancingCondition === "yes") {
            let dateComponents = data.financingConditionDate.split("/");
            conditionOfFinancingDate = dayjs(dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0]);
            let maxDate = dayjs('2069-12-31');
            if (data.financingConditionDate == "Invalid Date" || data.financingConditionDate.trim() == "" || conditionOfFinancingDate > maxDate || conditionOfFinancingDate < dayjs()) {
                setDisplayFinancingDateError(true);
                return;
            }
            setDisplayFinancingDateError(false);
        } else {
            dispatch(setFinancingConditionDate(""));
        }

        dispatch(setFinancingConditionExists(includeFinancingCondition));
        dispatch(setFinancingConditionDate(data.financingConditionDate));

        setRemainingBalanceAmount(data.remainingBalance);
        dispatch(setMortgageBalance(+newRemainingBalanceAmount));

        setIsSaving(true);
        await client.apiDealsApplicationsMortgagesSubjectProperty(new PropertyForCreationDto({
            applicationId: 0,
            remainingBalanceAmount: +newRemainingBalanceAmount,
            downPaymentAmount: application.downPayment,
            totalLoanAmount: application.applicationCategory == applicationCategory.Buy ? propertyInfo.purchasePrice - application.downPayment : application.totalLoan,
            newMoneyRequestedAmount: 0,
            subjectProperty: new SubjectPropertyDto({
                originalPurchasePrice: +newOriginalPriceAmount,
                purchasePrice: application.applicationCategory == applicationCategory.Buy ? +newPurchasePriceAmount : +newCurrentValueAmount,
                propertySalePrice: 0,
                address: new AddressDto({
                    id: 0,
                    streetNumber: methods.getValues("paStreetNumber"),
                    streetName: methods.getValues("paStreetName"),
                    streetType: methods.getValues("paStreetType"),
                    streetDirection: methods.getValues("paStreetDirection"),
                    unitType: methods.getValues("paUnitType"),
                    unitNumber: methods.getValues("paUnitNumber"),
                    city: methods.getValues("paCityName"),
                    region: methods.getValues("paProvinceName"),
                    postalCode: methods.getValues("paPostalCode"),
                    country: methods.getValues("paCountry"),
                    timeAtResidenceInMonths: 0,
                    residenceStatusType_Name: "",
                    deliveryMode: undefined,
                    modeNumber: undefined,
                    deliveryMode2: undefined,
                    modeNumber2: undefined,
                    isMailing: false
                }),
                propertyTax: +newPropertyTaxAmount,
                propertyTaxFrequency: "annually",
                mortgageHolder: data.mortgageHolder,
                livableArea: +data.livableArea,
                livableAreaType: data.livableAreaUnit,
                heatingCost: +newHeatingCostAmount,
                heatingType: data.heatingType,
                heatingCostFrequency: "monthly",
                condoFees: +newMaintenancFeeAmount,
                condoFeesFrequency: "monthly",
                futureStatusOfProperty: "",
                occupancyType: data.occupancy,
                subjectPropertyRentalUnits: +methods.getValues("subjectPropertyRentalUnitCount"),
                totalRentalUnits: +methods.getValues("rentalUnitCount"),
                totalRentalProperties: +methods.getValues("rentalPropertyCount"),
                ownershipPercentage: +methods.getValues("ownershipPercentage"),
                hasCurrentRentalProperties: data.ownRentalProperties === "yes",
                isPlanningOnRenting: data.partiallyRented === "yes",
                isSeparateLegalUnit: data.separateUnit === "yes",
                rent: +monthlyRentAmount,
                estimatedFundingDate: fundingDate,
                closingDate: closingDate,
                conditionOfFinancingDate: conditionOfFinancingDate,
                rentalIncome: +monthlyRentAmount,
            })
        })).then((result) => {

            setIsSaving(false);

        }).catch((error) => {
            setIsSaving(false);
            console.log("Error saving property information", error);
        });


        closeEdit();
    };

    const onError = (errors: object) => {
        console.log(errors);
    }

    const methods = useForm({
        defaultValues: {
            autoPaAddress: propertyAddress.unitNumber
                ? propertyAddress.unitNumber + "-"
                : "" +
                propertyAddress.streetNumber +
                " " +
                propertyAddress.streetName +
                ", " +
                propertyAddress.city +
                ", " +
                propertyAddress.province.slice(0, 2).toUpperCase() +
                " " +
                propertyAddress.postalCode,
            paStreetNumber: propertyAddress.streetNumber,
            paStreetName: propertyAddress.streetName,
            paStreetType: propertyAddress.streetType,
            paStreetDirection: propertyAddress.streetDirection,
            paUnitNumber: propertyAddress.unitNumber,
            paUnitType: propertyAddress.unitType,
            paCityName: propertyAddress.city,
            paProvinceName: propertyAddress.province,
            paPostalCode: propertyAddress.postalCode,
            paCountry: propertyAddress.country,
            purchasePrice: "", //For Mortgage Purchase
            currentPropertyValue: "",
            originalPurchasePrice: "", //For Mortgage Refinancing/Transfer
            remainingBalance: "",
            mortgageHolder: "",
            livableArea: "",
            livableAreaUnit: "",
            propertyTax: "",
            heatingCost: "",
            heatingType: "",
            maintenanceFee: "",
            occupancy: "",
            rentOut: false,
            partiallyRented: "no",
            separateUnit: false,
            monthlyRent: "",
            ownRentalProperties: "no",
            subjectPropertyRentalUnitCount: "",
            rentalPropertyCount: "",
            rentalUnitCount: "",
            ownershipPercentage: "",
            closingDate: "",
            fundingDate: "",
            financingConditionExists: "",
            financingConditionDate: ""
        },
    });

    useEffect(() => {
        const formattedPurchasePrice = propertyInfo.purchasePrice.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setPurchasePriceAmount(formattedPurchasePrice);

        const formattedPropertyValue = propertyInfo.propertyValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setCurrentValueAmount(formattedPropertyValue);

        const formattedOriginalPrice = propertyInfo.originalPurchasePrice.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setOriginalPriceAmount(formattedOriginalPrice);

        const formattedBalance = propertyInfo.mortgageBalance.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setRemainingBalanceAmount(formattedBalance);

        const formattedPropertyTax = propertyInfo.propertyTax.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setPropertyTaxAmount(formattedPropertyTax);

        const formattedHeatingCost = propertyInfo.heatingCost.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setHeatingCostAmount(formattedHeatingCost);

        const formattedMaintenanceFee = propertyInfo.maintenanceFee.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setMaintenanceFeeAmount(formattedMaintenanceFee);

        const formattedRent = propertyInfo.monthlyRent.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setRentAmount(formattedRent);

        methods.setValue("heatingType", propertyInfo ? propertyInfo.heatingType : "");
        methods.setValue("livableArea", propertyInfo ? propertyInfo.livableArea.toString() : "");
        methods.setValue("livableAreaUnit", propertyInfo.livableAreaUnit);
        methods.setValue("occupancy", propertyInfo ? propertyInfo.purposeOfProperty : "");
        setOccupancy(propertyInfo ? propertyInfo.purposeOfProperty : "");
        setPartiallyRented(propertyInfo.rentOut ? "yes" : "no");
        setSeparateUnitExists(propertyInfo.separateUnit ? "yes" : "no");
        setMonthlyRentAmount(propertyInfo.monthlyRent == 0 ? "" : propertyInfo.monthlyRent.toString());

        if (propertyInfo != undefined && propertyInfo.closingDate != undefined && propertyInfo.closingDate != "1901-01-01" && propertyInfo.closingDate != "") {
            let dateComponents = propertyInfo?.closingDate.split("/");
            let date = dayjs(dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0]);
            setClosingDateDisplayText(displayDateString(date));
        }
        if (propertyInfo != undefined && propertyInfo.fundingDate != undefined && propertyInfo.fundingDate != "1901-01-01" && propertyInfo.fundingDate != "") {
            let dateComponents = propertyInfo?.fundingDate.split("/");
            let date = dayjs(dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0]);
            setFundingDateDisplayText(displayDateString(date));
        }
        if (propertyInfo != undefined && propertyInfo.financingConditionDate != undefined && propertyInfo.financingConditionDate != "1901-01-01" && propertyInfo.financingConditionDate != "") {
            let dateComponents = propertyInfo?.financingConditionDate.split("/");
            let date = dayjs(dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0]);
            setFinancingConditionDisplayText(displayDateString(date));
        }

        if (assets != undefined && assets.length == 1) {
            let realEstateAsset = assets[0];
            let dateText = realEstateAsset.details.realEstate?.originalPurchaseDate ? realEstateAsset.details.realEstate?.originalPurchaseDate : "";
            let dateComponents = dateText.split("/");
            let date = dayjs(dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0]);
            setOriginalPurchaseDateText(displayDateString(date));
            setFutureUsageText(realEstateAsset.details.realEstate?.futureUsage ?
                realEstateAsset.details.realEstate?.futureUsage == "primary" ? "Will remain as my Primary" :
                    realEstateAsset.details.realEstate?.futureUsage == "selling" ? "Will be selling it" :
                        realEstateAsset.details.realEstate?.futureUsage == "renting" ? "Will be renting it out" :
                            realEstateAsset.details.realEstate?.futureUsage == "vacationproperty" ? "Will become secondary/vacation property" :
                                realEstateAsset.details.realEstate?.futureUsage == "endinglease" ? "Will be ending my lease"
                                    : "" : "");
            setPropertySoldText(realEstateAsset.details.realEstate?.hasPropertyBeenSold == "yes" ? "Yes" : "No");

            let saleDateText = realEstateAsset.details.realEstate?.soldDate ? realEstateAsset.details.realEstate?.soldDate : "";
            let saleDateComponents = saleDateText.split("/");
            let saleDate = dayjs(saleDateComponents[2] + "-" + saleDateComponents[1] + "-" + saleDateComponents[0]);
            setSaleDateText(displayDateString(saleDate));
        } else if (assets != undefined && assets.length > 1) {
            assets.forEach(asset => {
                if (asset.assetCategory == "realestate") {
                    let realEstateAsset = asset;
                    let dateText = realEstateAsset.details.realEstate?.originalPurchaseDate ? realEstateAsset.details.realEstate?.originalPurchaseDate : "";
                    let dateComponents = dateText.split("/");
                    let date = dayjs(dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0]);
                    setOriginalPurchaseDateText(displayDateString(date));
                    setFutureUsageText(realEstateAsset.details.realEstate?.futureUsage ?
                        realEstateAsset.details.realEstate?.futureUsage == "primary" ? "Will remain as my Primary" :
                            realEstateAsset.details.realEstate?.futureUsage == "selling" ? "Will be selling it" :
                                realEstateAsset.details.realEstate?.futureUsage == "renting" ? "Will be renting it out" :
                                    realEstateAsset.details.realEstate?.futureUsage == "vacationproperty" ? "Will become secondary/vacation property" :
                                        realEstateAsset.details.realEstate?.futureUsage == "endinglease" ? "Will be ending my lease"
                                            : "" : "");
                    setPropertySoldText(realEstateAsset.details.realEstate?.hasPropertyBeenSold == "yes" ? "Yes" : "No");

                    let saleDateText = realEstateAsset.details.realEstate?.soldDate ? realEstateAsset.details.realEstate?.soldDate : "";
                    let saleDateComponents = saleDateText.split("/");
                    let saleDate = dayjs(saleDateComponents[2] + "-" + saleDateComponents[1] + "-" + saleDateComponents[0]);
                    setSaleDateText(displayDateString(saleDate));
                }
            });
        }

        //For Refinance/Transfer, fetch property type
        if (application.applicationCategory != applicationCategory.Buy) {
            if (assets != undefined && assets.length > 0) {
                assets.forEach(asset => {
                    if (asset.assetCategory == "realestate") {
                        let realEstateAsset = asset;
                        switch (realEstateAsset.details.realEstate?.propertyType) {
                            case "singlefamily":
                                setPropertyTypeText("Single Family");
                                break;
                            case "semidetached":
                                setPropertyTypeText("Semi-Detached");
                                break;
                            case "duplex":
                                setPropertyTypeText("Duplex");
                                break;
                            case "triplex":
                                setPropertyTypeText("Triplex");
                                break;
                            case "fourplex":
                                setPropertyTypeText("Fourplex");
                                break;
                            case "commercialmix":
                                setPropertyTypeText("Commercial Mix");
                                break;
                            case "condo":
                                setPropertyTypeText("Condo");
                                break;
                            case "townhouse":
                                setPropertyTypeText("Townhouse");
                                break;
                            case "vacationpropertytypea":
                                setPropertyTypeText("Vacation Property-Type A");
                                break;
                            case "vacationpropertytypeb":
                                setPropertyTypeText("Vacation Property-Type B");
                                break;
                            default:
                                setPropertyTypeText("Unknown");
                                break;
                        }
                    }
                });
            }
        }

    }, []);

    useEffect(() => {
        const formattedPurchasePrice = propertyInfo.purchasePrice.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setPurchasePriceAmount(formattedPurchasePrice);

        const formattedOriginalPrice = propertyInfo.originalPurchasePrice.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setOriginalPriceAmount(formattedOriginalPrice);

        const formattedPropertyValue = propertyInfo.propertyValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setCurrentValueAmount(formattedPropertyValue);

        const formattedBalance = propertyInfo.mortgageBalance.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        setRemainingBalanceAmount(formattedBalance);
    }, [propertyInfo]);

    const occupancyChangeHandler = (e: any) => {
        if (occupancy != e.target.value) {
            setOwnRentalProperties("no");
            methods.setValue("ownRentalProperties", "no");
            setPartiallyRented("no");
            methods.setValue("partiallyRented", "no");
            setSeparateUnitExists("no");
            methods.setValue("separateUnit", false);
            setMonthlyRentAmount("");
            methods.setValue("monthlyRent", "");
            methods.setValue("subjectPropertyRentalUnitCount", "");
        }
        setOccupancy(e.target.value);
        methods.setValue("occupancy", e.target.value);
    };

    const partiallyRentedChangeHandler = (e: any) => {
        setPartiallyRented(e.target.value);
        methods.setValue("partiallyRented", e.target.value);
        if (e.target.value = "no") {
            setSeparateUnitExists("no");
            methods.setValue("separateUnit", false);
            setMonthlyRentAmount("");
            methods.setValue("monthlyRent", "");
        }
    };

    const separateUnitChangeHandler = (e: any) => {
        setSeparateUnitExists(e.target.value);
        methods.setValue("separateUnit", e.target.value);
        if (e.target.value = "no") {
            setMonthlyRentAmount("");
            methods.setValue("monthlyRent", "");
        }
    };

    const ownPropertiesChangeHandler = (e: any) => {
        setOwnRentalProperties(e.target.value);
        methods.setValue("ownRentalProperties", e.target.value);
        if (e.target.value === "no") {
            methods.setValue("rentalPropertyCount", "");
            methods.setValue("rentalUnitCount", "");
        }
    };

    const financingConditionChangeHandler = (e: any) => {
        setIncludeFinancingCondition(e.target.value);
        methods.setValue("financingConditionExists", e.target.value);
        if (e.target.value === "no") {
            methods.setValue("financingConditionDate", "");
            setFinancingConditionDateText(dayjs);
        }
    };

    return (
        <div className="mt-5">
            <div className="flex flex-row justify-between mt-5">
                <h2>Property Details</h2>
                {!showEdit && !props.restrictEditing && (
                    <h3
                        className="brand-blue-text text-xs grid grid-flow-col cursor-pointer"
                        onClick={() => {
                            application.applicationCategory != applicationCategory.Buy ? navigate("/single/refi-property-details", { state: { editMode: true } }) : openEdit();
                        }}
                    >
                        <img
                            src="assets/edit-icon.svg"
                            className={style.editIcon}
                            alt="edit"
                        />
                        <span>Edit</span>
                    </h3>
                )}
            </div>
            <AnimatePresence mode="wait" initial={false}>
                {!showEdit ?
                    <>
                        {application.applicationCategory === applicationCategory.Buy &&
                            <motion.div
                                key="10"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                onAnimationComplete={() => {
                                    document.addEventListener("click", handlePropertyChange);
                                    return () => document.removeEventListener("click", handlePropertyChange);
                                }}>
                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Property Address</p>
                                        <h3 className={style.addressDetails + " mt-3"}>
                                            {propertyAddress?.unitNumber ? propertyAddress?.unitNumber + "-" : ""}
                                            {propertyAddress.streetNumber} {propertyAddress.streetName} {propertyAddress.streetType},{" "}
                                            {propertyAddress.city}, {propertyAddress.province},{" "}
                                            {propertyAddress.postalCode},{" "}
                                            {propertyAddress.country}
                                        </h3>
                                    </div>
                                </div>
                                <div className="flex md:flex-row flex-col">
                                    {application.applicationCategory == applicationCategory.Buy &&
                                        <>
                                            <div className={style.twoColFirst}>
                                                <p className="mt-5 text-sm">Estimated Purchase Price</p>
                                                <h3 className="mt-3">{purchasePriceAmount}</h3>
                                            </div>
                                            <div>
                                                <p className="mt-5 text-sm">Livable Area</p>
                                                <h3 className="mt-3">{propertyInfo?.livableArea} {propertyInfo.livableAreaUnit === "squarefeet" ? "Sq. ft." : "Sq. Metres"}</h3>
                                            </div>
                                        </>
                                    }
                                    {application.applicationCategory != applicationCategory.Buy &&
                                        <>
                                            <div className={style.twoColFirst}>
                                                <p className="mt-5 text-sm">Estimated Property Value</p>
                                                <h3 className="mt-3">{currentValueAmount}</h3>
                                            </div>
                                            <div>
                                                <p className="mt-5 text-sm">Original Purchase Price</p>
                                                <h5 className="mt-3">{originalPriceAmount}</h5>
                                            </div>
                                        </>
                                    }
                                </div>
                                {application.applicationCategory != applicationCategory.Buy &&
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Current Balance</p>
                                            <h3 className="mt-3">{remainingBalanceAmount}</h3>
                                        </div>
                                        <div>
                                            <p className="mt-5 text-sm">Mortgage Lender</p>
                                            <h3 className="mt-3">{propertyInfo?.mortgageHolder}</h3>
                                        </div>
                                    </div>
                                }
                                <div className="flex md:flex-row flex-col">
                                    {application.applicationCategory != applicationCategory.Buy &&
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Estimated Livable Area</p>
                                            <h3 className="mt-3">{propertyInfo?.livableArea} {propertyInfo.livableAreaUnit === "squarefeet" ? "Sq. ft." : "Sq. Metres"}</h3>
                                        </div>
                                    }
                                    <div className={application.applicationCategory == applicationCategory.Buy ? style.twoColFirst : ""}>
                                        <p className="mt-5 text-sm">Property Tax</p>
                                        <h3 className="mt-3">{propertyTaxAmount}</h3>
                                    </div>
                                </div>
                                <div className="flex md:flex-row flex-col">
                                    {heatingCostAmount != "$0" && heatingCostAmount != "" &&
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Estimated Heating Cost</p>
                                            <h3 className="mt-3">{heatingCostAmount} </h3>
                                        </div>
                                    }
                                    {propertyInfo?.heatingType.trim() != "" &&
                                        <div>
                                            <p className="mt-5 text-sm">Heating Type (Optional)</p>
                                            <h3 className="mt-3">
                                                {propertyInfo?.heatingType == "electricbaseboard" && "Electric Baseboard"}
                                                {propertyInfo?.heatingType == "forcedair" && "Forced Air Gas/Oil/Electric"}
                                                {propertyInfo?.heatingType == "geothermal" && "Geothermal"}
                                                {propertyInfo?.heatingType == "hotwater" && "Hot Water Heating"}
                                                {propertyInfo?.heatingType == "oil" && "Oil"}
                                                {propertyInfo?.heatingType == "other" && "Other"}
                                            </h3>
                                        </div>
                                    }
                                </div>
                                {maintenanceFeeAmount != "$0" && maintenanceFeeAmount != "" &&
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Condo/Maintenance Fee (if applicable)</p>
                                            <h3 className="mt-3">{maintenanceFeeAmount} </h3>
                                        </div>
                                    </div>
                                }

                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Occupancy</p>
                                        <h3 className="mt-3">{propertyInfo?.purposeOfProperty} </h3>
                                    </div>
                                    {(propertyInfo?.purposeOfProperty === "I'll rent it out") &&

                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Monthly Rent</p>
                                            <h3 className="mt-3">{rentAmount}</h3>
                                        </div>
                                    }
                                </div>
                                {(propertyInfo?.purposeOfProperty === "I'll rent it out") &&
                                    <>
                                        <div className="flex md:flex-row flex-col">
                                            <div className={style.twoColFirst}>
                                                <p className="mt-5 text-sm">Ownership Percentage</p>
                                                <h3 className="mt-3">{propertyInfo?.ownershipPercentage}%</h3>
                                            </div>
                                        </div>
                                        <div className="flex md:flex-row flex-col">
                                            <div className={style.twoColFirst}>
                                                <p className="mt-5 text-sm">How many rental units are in this property?</p>
                                                <h3 className="mt-3">{propertyInfo?.subjectPropertyRentalUnits}</h3>
                                            </div>
                                            <div className={style.twoColFirst}>
                                                <p className="mt-5 text-sm">Do you currently own any rental properties?</p>
                                                <h3 className="mt-3">{propertyInfo?.ownOtherRentalProperties ? "Yes" : "No"}</h3>
                                            </div>
                                        </div>
                                    </>
                                }
                                {(propertyInfo?.purposeOfProperty === "I'll live there") &&
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Do you plan to rent out part of your home?</p>
                                            <h3 className="mt-3">{propertyInfo?.rentOut ? "Yes" : "No"}</h3>
                                        </div>
                                        {propertyInfo?.rentOut &&
                                            <div className={style.twoColFirst}>
                                                <p className="mt-5 text-sm">Is it a separate and legal unit?</p>
                                                <h3 className="mt-3">{propertyInfo?.separateUnit ? "Yes" : "No"}</h3>
                                            </div>
                                        }
                                    </div>
                                }
                                {propertyInfo?.rentOut && propertyInfo?.separateUnit &&
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Monthly Rent</p>
                                            <h3 className="mt-3">{rentAmount}</h3>
                                        </div>
                                    </div>
                                }
                                {propertyInfo?.purposeOfProperty === "I'll rent it out" && propertyInfo?.ownOtherRentalProperties &&
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Total number of rental properties</p>
                                            <h3 className="mt-3">{propertyInfo?.numOfRentalProperties}</h3>
                                        </div>
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Total number of rental units</p>
                                            <h3 className="mt-3">{propertyInfo?.numOfRentalUnits}</h3>
                                        </div>
                                    </div>
                                }

                                {application.applicationCategory == applicationCategory.Buy ?
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Estimated Closing Date</p>
                                            <h3 className="mt-3">{closingDateDisplayText}</h3>
                                        </div>
                                    </div>
                                    :
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Estimated Funding Date</p>
                                            <h3 className="mt-3">{fundingDateDisplayText}</h3>
                                        </div>
                                    </div>
                                }
                                {application.applicationCategory == applicationCategory.Buy &&
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Does your offer have a financing condition?</p>
                                            <h3 className="mt-3">{propertyInfo?.financingConditionExists === "yes" ? "Yes" : "No"}</h3>
                                        </div>
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Condition of financing date</p>
                                            <h3 className="mt-3">{propertyInfo?.financingConditionDate ? financingConditionDisplayText : "N/A"}</h3>
                                        </div>
                                    </div>
                                }
                            </motion.div>
                        }
                        {application.applicationCategory != applicationCategory.Buy &&
                            <motion.div
                                key="20"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                onAnimationComplete={() => {
                                    document.addEventListener("click", handlePropertyChange);
                                    return () => document.removeEventListener("click", handlePropertyChange);
                                }}>
                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Property Address</p>
                                        <h3 className={style.addressDetails + " mt-3"}>
                                            {propertyAddress?.unitNumber ? propertyAddress?.unitNumber + "-" : ""}
                                            {propertyAddress.streetNumber} {propertyAddress.streetName} {propertyAddress.streetType},{" "}
                                            {propertyAddress.city}, {propertyAddress.province},{" "}
                                            {propertyAddress.postalCode},{" "}
                                            {propertyAddress.country}
                                        </h3>
                                    </div>
                                </div>
                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Estimated Property Value</p>
                                        <h3 className="mt-3">{currentValueAmount}</h3>
                                    </div>
                                    <div className="">
                                        <p className="mt-5 text-sm">Current Balance</p>
                                        <h3 className="mt-3">{remainingBalanceAmount}</h3>
                                    </div>
                                </div>
                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Original Purchase Price</p>
                                        <h5 className="mt-3">{originalPriceAmount}</h5>
                                    </div>
                                    {originalPurchaseDateText != "" &&
                                        <div className="">
                                            <p className="mt-5 text-sm">Original purchase date (optional)</p>
                                            <h5 className="mt-3">{originalPurchaseDateText}</h5>
                                        </div>
                                    }
                                </div>
                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Mortgage Lender</p>
                                        <h3 className="mt-3">{propertyInfo?.mortgageHolder}</h3>
                                    </div>
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Who owns this property?</p>
                                        <h3 className="mt-3">{applicant?.firstName} {applicant?.lastName}</h3>
                                    </div>
                                </div>

                                <hr className="mt-5" />

                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Property type</p>
                                        <h3 className="mt-3">{propertyTypeText}</h3>
                                    </div>
                                    <div>
                                        <p className="mt-5 text-sm">Estimated Livable Area</p>
                                        <h3 className="mt-3">{propertyInfo?.livableArea} {propertyInfo.livableAreaUnit === "squarefeet" ? "Sq. ft." : "Sq. Metres"}</h3>
                                    </div>
                                </div>
                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Estimated Annual Property Tax</p>
                                        <h3 className="mt-3">{propertyTaxAmount}</h3>
                                    </div>
                                    {maintenanceFeeAmount != "$0" && maintenanceFeeAmount != "" &&
                                        <div className="">
                                            <p className="mt-5 text-sm">Condo/Maintenance Fee (if applicable)</p>
                                            <h3 className="mt-3">{maintenanceFeeAmount} </h3>
                                        </div>
                                    }
                                </div>
                                <div className="flex md:flex-row flex-col">
                                    {heatingCostAmount != "$0" && heatingCostAmount != "" &&
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Estimated Heating Cost</p>
                                            <h3 className="mt-3">{heatingCostAmount} </h3>
                                        </div>
                                    }
                                    {propertyInfo?.heatingType.trim() != "" &&
                                        <div>
                                            <p className="mt-5 text-sm">Heating Type (Optional)</p>
                                            <h3 className="mt-3">
                                                {propertyInfo?.heatingType == "electricbaseboard" && "Electric Baseboard"}
                                                {propertyInfo?.heatingType == "forcedair" && "Forced Air Gas/Oil/Electric"}
                                                {propertyInfo?.heatingType == "geothermal" && "Geothermal"}
                                                {propertyInfo?.heatingType == "hotwater" && "Hot Water Heating"}
                                                {propertyInfo?.heatingType == "oil" && "Oil"}
                                                {propertyInfo?.heatingType == "other" && "Other"}
                                            </h3>
                                        </div>
                                    }
                                </div>

                                <hr className="mt-5" />

                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Future Usage</p>
                                        <h3 className="mt-3">{futureUsageText} </h3>
                                    </div>
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Has the property been sold?</p>
                                        <h3 className="mt-3">{propertySoldText}</h3>
                                    </div>
                                </div>

                                {propertySoldText === "Yes" &&
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Date of Sale</p>
                                            <h3 className="mt-3">{saleDateText} </h3>
                                        </div>
                                    </div>
                                }

                                <hr className="mt-5" />

                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Occupancy</p>
                                        <h3 className="mt-3">{propertyInfo?.purposeOfProperty} </h3>
                                    </div>
                                    {(propertyInfo?.purposeOfProperty === "I'll rent it out") &&

                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Monthly Rent</p>
                                            <h3 className="mt-3">{rentAmount}</h3>
                                        </div>
                                    }
                                </div>
                                {(propertyInfo?.purposeOfProperty === "I'll rent it out") &&
                                    <>
                                        <div className="flex md:flex-row flex-col">
                                            <div className={style.twoColFirst}>
                                                <p className="mt-5 text-sm">Ownership Percentage</p>
                                                <h3 className="mt-3">{propertyInfo?.ownershipPercentage}%</h3>
                                            </div>
                                        </div>
                                        <div className="flex md:flex-row flex-col">
                                            <div className={style.twoColFirst}>
                                                <p className="mt-5 text-sm">How many rental units are in this property?</p>
                                                <h3 className="mt-3">{propertyInfo?.subjectPropertyRentalUnits}</h3>
                                            </div>
                                            <div className={style.twoColFirst}>
                                                <p className="mt-5 text-sm">Do you currently own any rental properties?</p>
                                                <h3 className="mt-3">{propertyInfo?.ownOtherRentalProperties ? "Yes" : "No"}</h3>
                                            </div>
                                        </div>
                                    </>
                                }
                                {(propertyInfo?.purposeOfProperty === "I'll live there") &&
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Do you plan to rent out part of your home?</p>
                                            <h3 className="mt-3">{propertyInfo?.rentOut ? "Yes" : "No"}</h3>
                                        </div>
                                        {propertyInfo?.rentOut &&
                                            <div className={style.twoColFirst}>
                                                <p className="mt-5 text-sm">Is it a separate and legal unit?</p>
                                                <h3 className="mt-3">{propertyInfo?.separateUnit ? "Yes" : "No"}</h3>
                                            </div>
                                        }
                                    </div>
                                }
                                {propertyInfo?.rentOut && propertyInfo?.separateUnit &&
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Monthly Rent</p>
                                            <h3 className="mt-3">{rentAmount}</h3>
                                        </div>
                                    </div>
                                }
                                {propertyInfo?.purposeOfProperty === "I'll rent it out" && propertyInfo?.ownOtherRentalProperties &&
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Total number of rental properties</p>
                                            <h3 className="mt-3">{propertyInfo?.numOfRentalProperties}</h3>
                                        </div>
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Total number of rental units</p>
                                            <h3 className="mt-3">{propertyInfo?.numOfRentalUnits}</h3>
                                        </div>
                                    </div>
                                }
                            </motion.div>
                        }
                    </>
                    :
                    <motion.div
                        key="11"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}>
                        <form onSubmit={methods.handleSubmit(onSubmit, onError)}>

                            <label htmlFor="property-search">Search for your address</label>
                            <div className="flex relative">
                                <span>
                                    <img
                                        src="assets/magnifying-glass-icon.svg"
                                        className={clsx(
                                            methods.formState?.errors?.autoPaAddress ? "hidden" : "",
                                            "w-5 h-5 absolute top-5",
                                            style.imageIcon
                                        )}
                                        alt="property-search"
                                        height={5}
                                        width={5}
                                    />
                                    <img
                                        src="assets/error-icon.svg"
                                        className={clsx(
                                            methods.formState?.errors?.autoPaAddress ? "" : "hidden",
                                            "w-4 h-4 absolute top-6"
                                        )}
                                        alt="error"
                                        height={5}
                                        width={5}
                                    />
                                </span>
                                <input
                                    autoComplete="off"
                                    className={clsx(
                                        methods.formState?.errors?.autoPaAddress?.message
                                            ? "error"
                                            : "",
                                        "mt-2",
                                        style.autoAddress
                                    )}
                                    id="property-search"
                                    type="text"
                                    placeholder="Start typing address"
                                    {...methods.register("autoPaAddress")}
                                />
                            </div>
                            <div className={clsx("ml-2 mt-2", showPropertyAddress ? "" : "hidden")}>
                                <p id="formatted-address"></p>
                                <span id="property-span-street-address"></span>
                                <br />
                                <span id="property-span-city"></span>
                                &nbsp;
                                <span id="property-span-state"></span>&nbsp;
                                <span id="property-span-postcode"></span>
                                <br />
                                <span id="property-span-country"></span>
                            </div>
                            {displayPropertyAddressError &&
                                <div className={clsx("flex flex-row pcaautocomplete mt-5", style.errorContainer)}>
                                    <img src="assets/error-info-icon.svg" alt="error" />
                                    <span className="text-sm ml-2 mt-1">
                                        Cannot proceed, property must be located in Ontario.
                                    </span>
                                </div>
                            }
                            <div className="flex lg:flex-row flex-col">
                                <div className={style.twoColFirst}>
                                    <p className="mt-5 text-sm">Street number</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.paStreetNumber
                                                        ? ""
                                                        : "hidden",
                                                    "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[300px]",
                                                    style.errorIcon
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <input
                                            className={clsx(
                                                methods.formState?.errors?.paStreetNumber?.message
                                                    ? "error"
                                                    : "",
                                                "mt-2",
                                                style.addInput
                                            )}
                                            type="text"
                                            id="streetNumber"
                                            maxLength={6}
                                            {...methods.register("paStreetNumber", {
                                                required: "Enter your street number",
                                                pattern: {
                                                    value: /^[ #a-zA-Z0-9._-]+$/,
                                                    message: "Enter a valid street number",
                                                },
                                            })}
                                        />
                                    </div>
                                    {methods.formState?.errors?.paStreetNumber?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.paStreetNumber.message}
                                        </span>
                                    )}
                                </div>
                                <div>
                                    <p className="mt-5 text-sm">Street name</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.paStreetName ? "" : "hidden",
                                                    "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[300px]"
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <input
                                            className={clsx(
                                                methods.formState?.errors?.paStreetName?.message
                                                    ? "error"
                                                    : "",
                                                "mt-2",
                                                style.addInput
                                            )}
                                            type="text"
                                            id="streetName"
                                            maxLength={23}
                                            {...methods.register("paStreetName", {
                                                required: "Enter your street name",
                                                pattern: {
                                                    value: /^[ #a-zA-ZÀ-Ÿ0-9._-]+$/,
                                                    message: "Enter a valid street name",
                                                },
                                            })}
                                        />
                                    </div>
                                    {methods.formState?.errors?.paStreetName?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.paStreetName.message}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="flex lg:flex-row flex-col">
                                <div className={style.twoColFirst}>
                                    <p className="mt-5 text-sm">Street Type</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.paStreetType
                                                        ? ""
                                                        : "hidden",
                                                    "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[300px]",
                                                    style.errorIcon
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <select
                                            id="paStreetType"
                                            className={clsx(
                                                methods.formState?.errors?.paStreetType?.message
                                                    ? "error"
                                                    : "",
                                                "mt-2 pt-2.5",
                                                style.addInput
                                            )}
                                            {...methods.register("paStreetType", {
                                                required: "Select a street type",
                                                onChange: (e) => {
                                                    methods.setValue("paStreetType", e.target.value);
                                                    methods.clearErrors("paStreetType");
                                                }
                                            })}
                                        >
                                            <option hidden value="">
                                                Street Type
                                            </option>
                                            <option value=""></option>
                                            {getStreetTypes}
                                        </select>
                                    </div>
                                    {methods.formState?.errors?.paStreetType?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.paStreetType.message}
                                        </span>
                                    )}
                                </div>
                                <div>
                                    <p className="mt-5 text-sm">Street Direction (optional)</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.paStreetDirection
                                                        ? ""
                                                        : "hidden",
                                                    "w-4 h-4 absolute top-6",
                                                    style.errorIcon
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <select
                                            id="streetDirection"
                                            {...methods.register("paStreetDirection")}
                                            className={clsx(
                                                methods.formState?.errors?.paStreetDirection?.message
                                                    ? "error"
                                                    : "",
                                                "mt-2 pt-2.5",
                                                style.addInput
                                            )}
                                            onChange={(e) => {
                                                methods.setValue("paStreetDirection", e.target.value);
                                                methods.clearErrors("paStreetDirection");
                                            }}
                                        >
                                            <option hidden value="">Direction</option>
                                            <option value=" "></option>
                                            <option value="S">S</option>
                                            <option value="SE">SE</option>
                                            <option value="N">N</option>
                                            <option value="NW">NW</option>
                                            <option value="W">W</option>
                                            <option value="SW">SW</option>
                                            <option value="NE">NE</option>
                                            <option value="E">E</option>
                                        </select>
                                    </div>
                                    {methods.formState?.errors?.paStreetDirection?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.paStreetDirection.message}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="flex lg:flex-row flex-col">
                                <div className={style.twoColFirst}>
                                    <p className="mt-5 text-sm">Unit Type (optional)</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.paUnitType
                                                        ? ""
                                                        : "hidden",
                                                    "w-4 h-4 absolute top-6",
                                                    style.errorIcon
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <select
                                            id="unitType"
                                            {...methods.register("paUnitType")}
                                            className={clsx(
                                                methods.formState?.errors?.paUnitType?.message
                                                    ? "error"
                                                    : "",
                                                "mt-2 pt-2.5",
                                                style.addInput
                                            )}
                                            onChange={(e) => {
                                                methods.setValue("paUnitType", e.target.value);
                                                if (e.target.value.trim() == "") {
                                                    methods.unregister("paUnitNumber");
                                                } else {
                                                    methods.register("paUnitNumber", {
                                                        required: "Enter your unit number",
                                                        pattern: {
                                                            value: /^[ #a-zA-Z0-9._-]+$/,
                                                            message: " Please enter a valid unit number",
                                                        },
                                                    });
                                                }
                                            }}
                                        >
                                            <option hidden value=""> Unit Type</option>
                                            <option value=" "></option>
                                            <option value="apt"> APT</option>
                                            <option value="unit"> UNIT</option>
                                            <option value="suite"> SUITE</option>
                                        </select>
                                    </div>
                                    {methods.formState?.errors?.paUnitType?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState?.errors?.paUnitType?.message.toString()}
                                        </span>
                                    )}
                                </div>
                                <div>
                                    <p className="mt-5 text-sm">Unit number (if applicable)</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.paUnitNumber ? "" : "hidden",
                                                    "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[300px]"
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <input
                                            className={clsx("mt-2", style.addInput)}
                                            type="text"
                                            id="unitNumber"
                                            maxLength={5}
                                            {...methods.register("paUnitNumber", {
                                                pattern: {
                                                    value: /^[ #a-zA-Z0-9._-]+$/,
                                                    message:
                                                        "Enter a valid unit number. Only letters, numbers and _-.# are accepted",
                                                },
                                            })}
                                            onChange={(e) => {
                                                methods.clearErrors("paUnitNumber");
                                            }}
                                        />
                                    </div>
                                    {methods.formState?.errors?.paUnitNumber?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1" style={{ whiteSpace: "pre-line" }}>
                                            {methods.formState?.errors?.paUnitNumber?.message?.toString()}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="flex lg:flex-row flex-col">
                                <div className={style.twoColFirst}>
                                    <p className="mt-5 text-sm">City</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.paCityName
                                                        ? ""
                                                        : "hidden",
                                                    "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[300px]",
                                                    style.errorIcon
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <input
                                            className={clsx(
                                                methods.formState?.errors?.paCityName?.message
                                                    ? "error"
                                                    : "",
                                                "mt-2",
                                                style.addInput
                                            )}
                                            type="text"
                                            id="paCityName"
                                            maxLength={40}
                                            {...methods.register("paCityName", {
                                                required: "Enter your city name",
                                                pattern: {
                                                    value: /^[ #a-zA-ZÀ-Ÿ0-9._'-]+$/,
                                                    message: "Enter a valid city name",
                                                },
                                            })}
                                        />
                                    </div>
                                    {methods.formState?.errors?.paCityName?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.paCityName.message}
                                        </span>
                                    )}
                                </div>
                                <div >
                                    <p className="mt-5 text-sm">Province</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.paProvinceName
                                                        ? ""
                                                        : "hidden",
                                                    "w-4 h-4 absolute top-6",
                                                    style.errorIcon
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <select
                                            {...methods.register("paProvinceName")}
                                            className={clsx(
                                                methods.formState?.errors?.paProvinceName?.message
                                                    ? "error"
                                                    : "",
                                                "mt-2 pt-2.5",
                                                style.addInput
                                            )}
                                            id="province"
                                        >
                                            <option hidden value="">
                                                Province
                                            </option>
                                            <option value="ON">Ontario</option>
                                        </select>
                                    </div>
                                    {methods.formState?.errors?.paProvinceName?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.paProvinceName.message}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="flex lg:flex-row flex-col">
                                <div className={style.twoColFirst}>
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Postal code</p>
                                        <div className="flex relative">
                                            <span>
                                                <img
                                                    src="assets/error-icon.svg"
                                                    className={clsx(
                                                        methods.formState?.errors?.paPostalCode
                                                            ? ""
                                                            : "hidden",
                                                        "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[300px]",
                                                        style.errorIcon
                                                    )}
                                                    alt="error"
                                                    height={5}
                                                    width={5}
                                                />
                                            </span>
                                            <input
                                                className={clsx(
                                                    methods.formState?.errors?.paPostalCode?.message
                                                        ? "error"
                                                        : "",
                                                    "mt-2",
                                                    style.addInput
                                                )}
                                                type="text"
                                                id="paPostalCode"
                                                maxLength={10}
                                                {...methods.register("paPostalCode", {
                                                    required: "Enter your postal code",
                                                    pattern: {
                                                        value:
                                                            /^(?!.*[dfioquDFIOQU])[a-vxyA-VXY][0-9][a-zA-Z] ?[0-9][a-zA-Z][0-9]$/,
                                                        message: "Enter a valid postal code",
                                                    },
                                                })}
                                                onChange={(e) => {
                                                    methods.setValue("paPostalCode", e.target.value.toUpperCase());
                                                }}
                                            />
                                        </div>
                                        {methods.formState?.errors?.paPostalCode?.message && (
                                            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                {methods.formState.errors.paPostalCode.message}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <p className="mt-5 text-sm">Country</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.paCountry ? "" : "hidden",
                                                    "w-4 h-4 absolute top-6",
                                                    style.errorIcon
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <select
                                            id="paCountry"
                                            className={clsx(
                                                methods.formState?.errors?.paCountry ? "error" : "",
                                                "mt-2 pt-2.5",
                                                style.addInput
                                            )}
                                            {...methods.register("paCountry", {})}
                                        >
                                            <option hidden value="">
                                                Country
                                            </option>
                                            <option value="Canada">Canada</option>
                                        </select>
                                    </div>
                                    {methods.formState?.errors?.paCountry && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            Select a valid country
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="flex md:flex-row flex-col">
                                {application.applicationCategory == applicationCategory.Buy && (
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Estimated Purchase Price</p>
                                        <div className="flex relative">
                                            <span>
                                                <img
                                                    src="assets/error-icon.svg"
                                                    className={clsx(
                                                        methods.formState?.errors?.purchasePrice
                                                            ? ""
                                                            : "hidden",
                                                        "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                    )}
                                                    alt="error"
                                                    height={5}
                                                    width={5}
                                                />
                                            </span>
                                            <CurrencyInput
                                                id="purchasePrice"
                                                placeholder="$"
                                                prefix={"$"}
                                                decimalsLimit={2}
                                                decimalScale={2}
                                                allowNegativeValue={false}
                                                maxLength={10}
                                                value={newPurchasePriceAmount}
                                                className={clsx(
                                                    methods.formState?.errors?.purchasePrice?.message ? "error" : "",
                                                    "mt-2 w:[220px] md:w-[305px]"
                                                )}
                                                {...methods.register("purchasePrice", {
                                                    required: "Enter the purchase price of the property.",
                                                })}
                                                onValueChange={(value, name, values) => {
                                                    value != undefined ? setNewPurchasePriceAmount(value) : setNewPurchasePriceAmount("")
                                                }}
                                            />
                                        </div>
                                        {methods.formState?.errors?.purchasePrice?.message && (
                                            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                {methods.formState.errors.purchasePrice.message}
                                            </span>
                                        )}
                                    </div>
                                )}
                                {application.applicationCategory != applicationCategory.Buy && (
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Estimated Property Value</p>
                                        <div className="flex relative">
                                            <span>
                                                <img
                                                    src="assets/error-icon.svg"
                                                    className={clsx(
                                                        methods.formState?.errors?.currentPropertyValue
                                                            ? ""
                                                            : "hidden",
                                                        "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                    )}
                                                    alt="error"
                                                    height={5}
                                                    width={5}
                                                />
                                            </span>
                                            <CurrencyInput
                                                id="currentValue"
                                                placeholder="$"
                                                prefix={"$"}
                                                decimalsLimit={2}
                                                decimalScale={2}
                                                allowNegativeValue={false}
                                                maxLength={10}
                                                value={newCurrentValueAmount}
                                                className={clsx(
                                                    methods.formState?.errors?.currentPropertyValue?.message ? "error" : "",
                                                    "mt-2 w:[220px] md:w-[305px]"
                                                )}
                                                {...methods.register("currentPropertyValue", {
                                                    required: "Enter the current value of your property.",
                                                })}
                                                onValueChange={(value, name, values) => {
                                                    value != undefined ? setNewCurrentValueAmount(value) : setNewCurrentValueAmount("")
                                                }}
                                            />
                                        </div>
                                        {methods.formState?.errors?.currentPropertyValue?.message && (
                                            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                {methods.formState.errors.currentPropertyValue.message}
                                            </span>
                                        )}
                                    </div>
                                )}
                                <div className="mt-3">
                                    <p className="text-sm">Livable Area</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.livableArea
                                                        ? ""
                                                        : "hidden",
                                                    "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[120px] xs:max-md:ml-[370px] md:ml-[345px]"
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.livableAreaUnit
                                                        ? ""
                                                        : "hidden",
                                                    "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[195px]"
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <input
                                            className={clsx(
                                                "mt-2 w:[220px] md:w-[222px]", style.livableArea
                                            )}
                                            {...methods.register("livableArea", {
                                                required: "Enter the livable area of your home.",
                                                validate: {
                                                    wholeCount: (v) =>
                                                        /^\d+$/.test(v)
                                                            ? true
                                                            : "Please enter a valid number.",
                                                },
                                            })}
                                            type="text"
                                            min={1}
                                            placeholder=""
                                            id="livableArea"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            maxLength={5}
                                            onInput={(e: any) => methods.setValue("livableArea", e.target.value.slice(0, 10))}
                                        />
                                        <select
                                            id="livableAreaUnit"
                                            {...methods.register("livableAreaUnit", {
                                                required: "Select a unit",
                                            })}
                                            defaultValue=""
                                            className={clsx(
                                                style.frequency, "mt-2 pt-2.5 ml-3"
                                            )}
                                        >
                                            <option hidden value="">
                                                Choose...
                                            </option>
                                            <option value="squarefeet">Sq. Ft</option>
                                            <option value="squaremetres">Sq. Metres</option>
                                        </select>
                                    </div>
                                    {methods.formState?.errors?.livableArea?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.livableArea.message}
                                        </span>
                                    )}
                                    {methods.formState?.errors?.livableAreaUnit?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.livableAreaUnit.message}
                                        </span>
                                    )}
                                </div>
                            </div>

                            {application.applicationCategory != applicationCategory.Buy &&
                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Original purchase price</p>
                                        <div className="flex relative">
                                            <span>
                                                <img
                                                    src="assets/error-icon.svg"
                                                    className={clsx(
                                                        methods.formState?.errors?.originalPurchasePrice
                                                            ? ""
                                                            : "hidden",
                                                        "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[430px]"
                                                    )}
                                                    alt="error"
                                                    height={5}
                                                    width={5}
                                                />
                                            </span>
                                            <CurrencyInput
                                                id="originalPurchasePrice"
                                                prefix={"$"}
                                                decimalsLimit={2}
                                                decimalScale={2}
                                                allowNegativeValue={false}
                                                value={newOriginalPriceAmount}
                                                maxLength={10}
                                                className={clsx(
                                                    methods.formState?.errors?.originalPurchasePrice?.message ? "error" : "",
                                                    "mt-2 w:[220px] md:w-[305px]"
                                                )}
                                                {...methods.register("originalPurchasePrice", {
                                                    required: "Enter the original purchase price your home",
                                                })}
                                                onValueChange={(value, name, values) => value != undefined ? setNewOriginalPriceAmount(value) : setNewOriginalPriceAmount("")}
                                            />
                                        </div>
                                        {methods.formState?.errors?.originalPurchasePrice?.message && (
                                            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                {methods.formState.errors.originalPurchasePrice.message}
                                            </span>
                                        )}
                                    </div>
                                    <div>
                                        <p className="mt-5 text-sm">Current balance</p>
                                        <div className="flex relative">
                                            <span>
                                                <img
                                                    src="assets/error-icon.svg"
                                                    className={clsx(
                                                        methods.formState?.errors?.remainingBalance
                                                            ? ""
                                                            : "hidden",
                                                        "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                    )}
                                                    alt="error"
                                                    height={5}
                                                    width={5}
                                                />
                                            </span>
                                            <CurrencyInput
                                                id="remainingBalance"
                                                prefix={"$"}
                                                decimalsLimit={2}
                                                decimalScale={2}
                                                allowNegativeValue={false}
                                                value={newRemainingBalanceAmount}
                                                maxLength={10}
                                                className={clsx(
                                                    methods.formState?.errors?.remainingBalance?.message ? "error" : "",
                                                    "mt-2 w:[220px] md:w-[305px]"
                                                )}
                                                {...methods.register("remainingBalance", {
                                                    required: "Enter the remaining balance of your existing mortgage",
                                                })}
                                                onValueChange={(value, name, values) => value != undefined ? setNewRemainingBalanceAmount(value) : setNewRemainingBalanceAmount("")}
                                            />
                                        </div>
                                        {methods.formState?.errors?.remainingBalance?.message && (
                                            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                {methods.formState.errors.remainingBalance.message}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            }


                            <div className="flex md:flex-row flex-col">
                                <div className={style.twoColFirst}>
                                    <p className="mt-5 text-sm">Property Tax</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.propertyTax
                                                        ? ""
                                                        : "hidden",
                                                    "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <CurrencyInput
                                            id="propertyTax"
                                            placeholder="$"
                                            prefix={"$"}
                                            decimalsLimit={2}
                                            decimalScale={2}
                                            allowNegativeValue={false}
                                            maxLength={7}
                                            value={newPropertyTaxAmount}
                                            className={clsx(
                                                methods.formState?.errors?.propertyTax?.message ? "error" : "",
                                                "mt-2 w:[220px] md:w-[305px]"
                                            )}
                                            {...methods.register("propertyTax", {
                                                required: "Enter an amount per year",
                                            })}
                                            onValueChange={(value, name, values) => {
                                                value != undefined ? setNewPropertyTaxAmount(value) : setNewPropertyTaxAmount("")
                                            }}
                                        />
                                    </div>
                                    {methods.formState?.errors?.propertyTax?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.propertyTax.message}
                                        </span>
                                    )}
                                </div>
                                {application.applicationCategory != applicationCategory.Buy &&
                                    <div>
                                        <p className="mt-5 text-sm">Mortgage Lender</p>
                                        <div className="flex relative">
                                            <span>
                                                <img
                                                    src="assets/error-icon.svg"
                                                    className={clsx(
                                                        methods.formState?.errors?.mortgageHolder ? "" : "hidden",
                                                        "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                    )}
                                                    alt="error"
                                                    height={5}
                                                    width={5}
                                                />
                                            </span>
                                            <input
                                                className={clsx(
                                                    methods.formState?.errors?.mortgageHolder?.message ? "error" : "",
                                                    "mt-2 w:[220px] md:w-[305px]"
                                                )}
                                                type="text"
                                                id="mortgageHolder"
                                                {...methods.register("mortgageHolder", {
                                                    required: "Enter the name of the mortgage lender",
                                                    maxLength: {
                                                        value: 200,
                                                        message: "Names exceeds maximum character count",
                                                    },
                                                    pattern: {
                                                        value: /^[a-zA-Z0-9 '-.]*$/,
                                                        message: "Please enter the current mortgage lender",
                                                    },
                                                    onBlur: () => {
                                                        methods.setValue("mortgageHolder", methods.getValues("mortgageHolder").trim());
                                                    },
                                                })}
                                            />
                                        </div>
                                        {methods.formState?.errors?.mortgageHolder?.message && (
                                            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                {methods.formState.errors.mortgageHolder.message}
                                            </span>
                                        )}
                                    </div>
                                }
                            </div>

                            <div className="flex md:flex-row flex-col">
                                <div className={style.twoColFirst}>
                                    <p className="mt-5 text-sm">Estimated Heating Cost</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.heatingCost
                                                        ? ""
                                                        : "hidden",
                                                    "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <CurrencyInput
                                            id="heatingCost"
                                            placeholder="$"
                                            prefix={"$"}
                                            decimalsLimit={2}
                                            decimalScale={2}
                                            allowNegativeValue={false}
                                            maxLength={7}
                                            value={newHeatingCostAmount}
                                            className={clsx(
                                                methods.formState?.errors?.heatingCost?.message ? "error" : "",
                                                "mt-2 w:[220px] md:w-[305px]"
                                            )}
                                            {...methods.register("heatingCost", {
                                                required: "Enter the estimated heating cost of your home",
                                                validate: {
                                                    heatingCost: (c) => {
                                                        let currentAmount = c.replaceAll("$", "").replaceAll(",", "").replaceAll("/month", "");
                                                        if (+currentAmount > 0) {
                                                            return true
                                                        } else {
                                                            return "The heating cost cannot be zero."
                                                        }
                                                    },
                                                },
                                            })}
                                            onValueChange={(value, name, values) => {
                                                value != undefined ? setNewHeatingCostAmount(value) : setNewHeatingCostAmount("")
                                            }}
                                        />
                                    </div>
                                    {methods.formState?.errors?.heatingCost?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.heatingCost.message}
                                        </span>
                                    )}
                                </div>
                                <div>
                                    <p className="mt-5 text-sm">Heating Type (Optional)</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.heatingType ? "" : "hidden",
                                                    "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[430px]"
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <select
                                            id="title"
                                            {...methods.register("heatingType", {})}
                                            defaultValue=""
                                            className={clsx(
                                                "", "mt-2 pt-2.5"
                                            )}
                                            style={{ maxWidth: 305 }}
                                        >
                                            <option hidden value="">
                                                Choose...
                                            </option>
                                            <option value="electricbaseboard">Electric Baseboard</option>
                                            <option value="forcedair">Forced Air Gas/Oil/Electric</option>
                                            <option value="geothermal">Geothermal</option>
                                            <option value="hotwater">Hot Water Heating</option>
                                            <option value="oil">Oil</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                    {methods.formState?.errors?.heatingType?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.heatingType.message}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="flex md:flex-row flex-col">
                                <div className={style.twoColFirst}>
                                    <p className="mt-5 text-sm">Condo/Maintenance Fee (if applicable)</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.maintenanceFee
                                                        ? ""
                                                        : "hidden",
                                                    "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <CurrencyInput
                                            id="maintenanceFee"
                                            placeholder="$"
                                            prefix={"$"}
                                            decimalsLimit={2}
                                            decimalScale={2}
                                            allowNegativeValue={false}
                                            maxLength={7}
                                            value={newMaintenancFeeAmount}
                                            className={clsx(
                                                methods.formState?.errors?.maintenanceFee?.message ? "error" : "",
                                                "mt-2 w:[220px] md:w-[305px]"
                                            )}
                                            {...methods.register("maintenanceFee", {})}
                                            onValueChange={(value, name, values) => {
                                                value != undefined ? setNewMaintenanceFeeAmount(value) : setNewMaintenanceFeeAmount("")
                                            }}
                                        />
                                    </div>
                                    {methods.formState?.errors?.maintenanceFee?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.maintenanceFee.message}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="flex md:flex-row flex-col">
                                <div className={style.twoColFirst}>
                                    <p className="mt-5 text-sm">Occupancy</p>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.occupancy ? "" : "hidden",
                                                    "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[430px]"
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <select
                                            defaultValue=""
                                            {...methods.register("occupancy", {
                                                required: "Please select an option",
                                                onChange: occupancyChangeHandler
                                            })}
                                            onChange={occupancyChangeHandler}
                                            className={clsx(
                                                "pt-2.5 mt-3"
                                            )}
                                            style={{ maxWidth: 305 }}
                                            id="occupancy"
                                        >
                                            <option hidden value="">
                                                Choose...
                                            </option>
                                            <option value="I'll live there">I'll live there</option>
                                            <option value="I'll rent it out">I'll rent it out</option>
                                            <option value="It will be my vacation home">It will be my vacation home</option>
                                            <option value="It will be a secondary property">It will be a secondary property</option>
                                        </select>
                                    </div>
                                    {methods.formState?.errors?.occupancy?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.occupancy.message}
                                        </span>
                                    )}
                                </div>
                                {occupancy == "I'll rent it out" &&
                                    <div>
                                        <p className="mt-5 text-sm">Monthly Rent</p>
                                        <div className="flex relative">
                                            <span>
                                                <img
                                                    src="assets/error-icon.svg"
                                                    className={clsx(
                                                        methods.formState?.errors?.monthlyRent
                                                            ? ""
                                                            : "hidden",
                                                        "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                    )}
                                                    alt="error"
                                                    height={5}
                                                    width={5}
                                                />
                                            </span>
                                            <CurrencyInput
                                                id="monthlyRent"
                                                placeholder="$"
                                                prefix={"$"}
                                                decimalsLimit={2}
                                                decimalScale={2}
                                                allowNegativeValue={false}
                                                value={monthlyRentAmount}
                                                maxLength={7}
                                                className={clsx(
                                                    methods.formState?.errors?.monthlyRent?.message ? "error" : "",
                                                    "mt-3 w:[220px] md:w-[305px]"
                                                )}
                                                {...methods.register("monthlyRent", {
                                                    required: "Enter the monthly rent of this unit",
                                                })}
                                                onValueChange={(value, name, values) => value != undefined ? setMonthlyRentAmount(value) : setMonthlyRentAmount("")}
                                            />
                                        </div>
                                        {methods.formState?.errors?.monthlyRent?.message && (
                                            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                {methods.formState.errors.monthlyRent.message}
                                            </span>
                                        )}
                                    </div>
                                }
                            </div>

                            {occupancy == "I'll live there" &&
                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Are you planning to rent out part of your home?</p>
                                        <div className="grid grid-flow-row sm:grid-flow-col mb-6">
                                            <ul className="grid grid-cols-3 gap-x-2 mt-2 max-w-md" style={{ maxWidth: "20rem" }}>
                                                <li className="relative">
                                                    <input
                                                        type="radio"
                                                        value="yes"
                                                        id="yes-partial-rent"
                                                        {...methods.register("partiallyRented", {
                                                            onChange: partiallyRentedChangeHandler,
                                                        })}
                                                        checked={partiallyRented === "yes"}
                                                        onChange={partiallyRentedChangeHandler}
                                                        className="sr-only peer "
                                                    />
                                                    <label
                                                        className={clsx(
                                                            style.phoneLabel,
                                                            "cursor-pointer focus:outline-none hover:bg-gray-100 peer-checked:ring-[--brand-blue] peer-checked:ring-2 peer-checked:border-transparent text-sm text-center",
                                                            methods.formState?.errors?.partiallyRented?.message
                                                                ? style.labelError
                                                                : ""
                                                        )}
                                                        htmlFor="yes-partial-rent"
                                                    >
                                                        <p className="p-2 brand-blue-text leading-6" style={{ lineHeight: "1.5rem" }}>Yes</p>
                                                    </label>
                                                </li>
                                                <li className="relative">
                                                    <input
                                                        type="radio"
                                                        value="no"
                                                        id="no-partial-rent"
                                                        {...methods.register("partiallyRented", {
                                                            onChange: partiallyRentedChangeHandler,
                                                        })}
                                                        checked={partiallyRented === "no"}
                                                        onChange={partiallyRentedChangeHandler}
                                                        className="sr-only peer leading-6"
                                                    />
                                                    <label
                                                        className={clsx(
                                                            style.phoneLabel,
                                                            "cursor-pointer focus:outline-none hover:bg-gray-100 peer-checked:ring-[--brand-blue] peer-checked:ring-2 peer-checked:border-transparent text-sm text-center",
                                                            methods.formState?.errors?.partiallyRented?.message
                                                                ? style.labelError
                                                                : ""
                                                        )}
                                                        htmlFor="no-partial-rent"
                                                    >
                                                        <p className="p-2 brand-blue-text leading-6" style={{ lineHeight: "1.5rem" }}>No</p>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {partiallyRented === "yes" &&
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Is it a separate and legal unit?</p>
                                            <div className="grid grid-flow-row sm:grid-flow-col mb-6">
                                                <ul className="grid grid-cols-3 gap-x-2 mt-2 max-w-md" style={{ maxWidth: "20rem" }}>
                                                    <li className="relative">
                                                        <input
                                                            type="radio"
                                                            value="yes"
                                                            id="yes-separate-unit"
                                                            {...methods.register("separateUnit", {
                                                                onChange: separateUnitChangeHandler,
                                                            })}
                                                            checked={separateUnitExists === "yes"}
                                                            onChange={separateUnitChangeHandler}
                                                            className="sr-only peer "
                                                        />
                                                        <label
                                                            className={clsx(
                                                                style.phoneLabel,
                                                                "cursor-pointer focus:outline-none hover:bg-gray-100 peer-checked:ring-[--brand-blue] peer-checked:ring-2 peer-checked:border-transparent text-sm text-center",
                                                                methods.formState?.errors?.separateUnit?.message
                                                                    ? style.labelError
                                                                    : ""
                                                            )}
                                                            htmlFor="yes-separate-unit"
                                                        >
                                                            <p className="p-2 brand-blue-text leading-6" style={{ lineHeight: "1.5rem" }}>Yes</p>
                                                        </label>
                                                    </li>
                                                    <li className="relative">
                                                        <input
                                                            type="radio"
                                                            value="no"
                                                            id="no-separate-unit"
                                                            {...methods.register("separateUnit", {
                                                                onChange: separateUnitChangeHandler,
                                                            })}
                                                            checked={separateUnitExists === "no"}
                                                            onChange={separateUnitChangeHandler}
                                                            className="sr-only peer leading-6"
                                                        />
                                                        <label
                                                            className={clsx(
                                                                style.phoneLabel,
                                                                "cursor-pointer focus:outline-none hover:bg-gray-100 peer-checked:ring-[--brand-blue] peer-checked:ring-2 peer-checked:border-transparent text-sm text-center",
                                                                methods.formState?.errors?.separateUnit?.message
                                                                    ? style.labelError
                                                                    : ""
                                                            )}
                                                            htmlFor="no-separate-unit"
                                                        >
                                                            <p className="p-2 brand-blue-text leading-6" style={{ lineHeight: "1.5rem" }}>No</p>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }

                            {separateUnitExists === "yes" &&
                                <div className="flex md:flex-row flex-col w-max">
                                    <div>
                                        <p className="text-sm">Monthly Rent</p>
                                        <div className="flex relative">
                                            <span>
                                                <img
                                                    src="assets/error-icon.svg"
                                                    className={clsx(
                                                        methods.formState?.errors?.monthlyRent
                                                            ? ""
                                                            : "hidden",
                                                        "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                    )}
                                                    alt="error"
                                                    height={5}
                                                    width={5}
                                                />
                                            </span>
                                            <CurrencyInput
                                                id="monthlyRent"
                                                placeholder="$"
                                                prefix={"$"}
                                                decimalsLimit={2}
                                                decimalScale={2}
                                                allowNegativeValue={false}
                                                value={monthlyRentAmount}
                                                maxLength={7}
                                                className={clsx(
                                                    methods.formState?.errors?.monthlyRent?.message ? "error" : "",
                                                    "mt-2 w:[220px] md:w-[305px]"
                                                )}
                                                {...methods.register("monthlyRent", {
                                                    required: "Enter the monthly rent of this unit",
                                                })}
                                                onValueChange={(value, name, values) => value != undefined ? setMonthlyRentAmount(value) : setMonthlyRentAmount("")}
                                            />
                                        </div>
                                        {methods.formState?.errors?.monthlyRent?.message && (
                                            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                {methods.formState.errors.monthlyRent.message}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            }

                            {occupancy == "I'll rent it out" &&
                                <>
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Ownership Percentage</p>
                                            <div className="flex relative mb-3">
                                                <span>
                                                    <img
                                                        src="assets/error-icon.svg"
                                                        className={clsx(
                                                            methods.formState?.errors?.ownershipPercentage
                                                                ? ""
                                                                : "hidden",
                                                            "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                        )}
                                                        alt="error"
                                                        height={5}
                                                        width={5}
                                                    />
                                                </span>
                                                <input
                                                    className={clsx(
                                                        methods.formState?.errors?.ownershipPercentage?.message
                                                            ? "error"
                                                            : "",
                                                        "mt-2 w:[220px] md:w-[305px]"
                                                    )}
                                                    {...methods.register("ownershipPercentage", {
                                                        required: "Enter the ownership of this property in percentage value.",
                                                        validate: {
                                                            wholePercent: (v) =>
                                                                /^\d+$/.test(v) && +v > 0 && +v <= 100
                                                                    ? true
                                                                    : "Please enter a whole number between 1 and 100.",
                                                        },
                                                    })}
                                                    type="text"
                                                    id="ownershipPercentage"
                                                    placeholder="%"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    maxLength={3}
                                                />
                                            </div>
                                            {methods.formState?.errors?.ownershipPercentage?.message && (
                                                <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                    {methods.formState.errors.ownershipPercentage.message}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex md:flex-row flex-col">
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">How many rental units are in this property?</p>
                                            <div className="flex relative">
                                                <span>
                                                    <img
                                                        src="assets/error-icon.svg"
                                                        className={clsx(
                                                            methods.formState?.errors?.subjectPropertyRentalUnitCount
                                                                ? ""
                                                                : "hidden",
                                                            "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                        )}
                                                        alt="error"
                                                        height={5}
                                                        width={5}
                                                    />
                                                </span>
                                                <input
                                                    className={clsx(
                                                        methods.formState?.errors?.subjectPropertyRentalUnitCount?.message
                                                            ? "error"
                                                            : "",
                                                        "mt-2 w:[220px] md:w-[305px]"
                                                    )}
                                                    {...methods.register("subjectPropertyRentalUnitCount", {
                                                        required: "Enter the number of rental units in this property.",
                                                        validate: {
                                                            wholeCount: (v) =>
                                                                /^\d+$/.test(v)
                                                                    ? true
                                                                    : "Please enter a valid number.",
                                                        },
                                                    })}
                                                    type="text"
                                                    id="subjectPropertyRentalUnitCount"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    maxLength={5}
                                                />
                                            </div>
                                            {methods.formState?.errors?.subjectPropertyRentalUnitCount?.message && (
                                                <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                    {methods.formState.errors.subjectPropertyRentalUnitCount.message}
                                                </span>
                                            )}
                                        </div>
                                        <div className={style.twoColFirst}>
                                            <p className="mt-5 text-sm">Do you currently own any rental properties?</p>
                                            <div className="grid grid-flow-row sm:grid-flow-col mb-6">
                                                <ul className="grid grid-cols-3 gap-x-2 mt-2 max-w-md" style={{ maxWidth: "20rem" }}>
                                                    <li className="relative">
                                                        <input
                                                            type="radio"
                                                            value="yes"
                                                            id="yes-own-rental-properties"
                                                            {...methods.register("ownRentalProperties", {
                                                                onChange: ownPropertiesChangeHandler,
                                                            })}
                                                            checked={ownRentalProperties === "yes"}
                                                            onChange={ownPropertiesChangeHandler}
                                                            className="sr-only peer "
                                                        />
                                                        <label
                                                            className={clsx(
                                                                style.phoneLabel,
                                                                "cursor-pointer focus:outline-none hover:bg-gray-100 peer-checked:ring-[--brand-blue] peer-checked:ring-2 peer-checked:border-transparent text-sm text-center",
                                                                methods.formState?.errors?.ownRentalProperties?.message
                                                                    ? style.labelError
                                                                    : ""
                                                            )}
                                                            htmlFor="yes-own-rental-properties"
                                                        >
                                                            <p className="p-2 brand-blue-text leading-6" style={{ lineHeight: "1.5rem" }}>Yes</p>
                                                        </label>
                                                    </li>
                                                    <li className="relative">
                                                        <input
                                                            type="radio"
                                                            value="no"
                                                            id="no-own-rental-properties"
                                                            {...methods.register("ownRentalProperties", {
                                                                onChange: ownPropertiesChangeHandler,
                                                            })}
                                                            checked={ownRentalProperties === "no"}
                                                            onChange={ownPropertiesChangeHandler}
                                                            className="sr-only peer leading-6"
                                                        />
                                                        <label
                                                            className={clsx(
                                                                style.phoneLabel,
                                                                "cursor-pointer focus:outline-none hover:bg-gray-100 peer-checked:ring-[--brand-blue] peer-checked:ring-2 peer-checked:border-transparent text-sm text-center",
                                                                methods.formState?.errors?.ownRentalProperties?.message
                                                                    ? style.labelError
                                                                    : ""
                                                            )}
                                                            htmlFor="no-own-rental-properties"
                                                        >
                                                            <p className="p-2 brand-blue-text leading-6" style={{ lineHeight: "1.5rem" }}>No</p>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    {ownRentalProperties === "yes" &&
                                        <div className="flex md:flex-row flex-col">
                                            <div className={style.twoColFirst}>
                                                <p className="text-sm">Total number of rental properties</p>
                                                <div className="flex relative">
                                                    <span>
                                                        <img
                                                            src="assets/error-icon.svg"
                                                            className={clsx(
                                                                methods.formState?.errors?.rentalPropertyCount
                                                                    ? ""
                                                                    : "hidden",
                                                                "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                            )}
                                                            alt="error"
                                                            height={5}
                                                            width={5}
                                                        />
                                                    </span>
                                                    <input
                                                        className={clsx(
                                                            methods.formState?.errors?.rentalPropertyCount?.message
                                                                ? "error"
                                                                : "",
                                                            "mt-2 w:[220px] md:w-[305px]"
                                                        )}
                                                        {...methods.register("rentalPropertyCount", {
                                                            required: "Enter the number of rental properties you currently own.",
                                                            validate: {
                                                                wholeCount: (v) =>
                                                                    /^\d+$/.test(v)
                                                                        ? true
                                                                        : "Please enter a valid number.",
                                                            },
                                                        })}
                                                        type="text"
                                                        id="rentalPropertyCount"
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                        maxLength={5}
                                                    />
                                                </div>
                                                {methods.formState?.errors?.rentalPropertyCount?.message && (
                                                    <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                        {methods.formState.errors.rentalPropertyCount.message}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="flex md:flex-row flex-col">
                                                <div className={style.twoColFirst}>
                                                    <p className="text-sm">Total number of rental units</p>
                                                    <div className="flex relative">
                                                        <span>
                                                            <img
                                                                src="assets/error-icon.svg"
                                                                className={clsx(
                                                                    methods.formState?.errors?.rentalUnitCount
                                                                        ? ""
                                                                        : "hidden",
                                                                    "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[275px]"
                                                                )}
                                                                alt="error"
                                                                height={5}
                                                                width={5}
                                                            />
                                                        </span>
                                                        <input
                                                            className={clsx(
                                                                methods.formState?.errors?.rentalUnitCount?.message
                                                                    ? "error"
                                                                    : "",
                                                                "mt-2 w:[220px] md:w-[305px]"
                                                            )}
                                                            {...methods.register("rentalUnitCount", {
                                                                required: "Enter the number of rental units you currently own.",
                                                                validate: {
                                                                    wholeCount: (v) =>
                                                                        /^\d+$/.test(v)
                                                                            ? true
                                                                            : "Please enter a valid number.",
                                                                },
                                                            })}
                                                            type="text"
                                                            id="rentalUnitCount"
                                                            inputMode="numeric"
                                                            pattern="[0-9]*"
                                                            maxLength={5}
                                                        />
                                                    </div>
                                                    {methods.formState?.errors?.rentalUnitCount?.message && (
                                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                                            {methods.formState.errors.rentalUnitCount.message}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </>
                            }

                            <div className="flex md:flex-row flex-col">
                                <div>
                                    <p className={clsx(separateUnitExists === "yes" || ownRentalProperties === "yes" ||
                                        (occupancy == "It will be my vacation home" || occupancy == "It will be a secondary property") ? "mt-5" : "", "text-sm")}>
                                        {application.applicationCategory == applicationCategory.Buy ? "Estimated Closing Date" : "Estimated Funding Date"}</p>
                                    {application.applicationCategory == applicationCategory.Buy &&
                                        <>
                                            <div className="flex relative mt-2">
                                                <span>
                                                    <img
                                                        src="assets/error-icon.svg"
                                                        className={clsx(
                                                            methods.formState?.errors?.closingDate?.message
                                                                ? ""
                                                                : "hidden",
                                                            "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[195px]"
                                                        )}
                                                        alt="error"
                                                        height={5}
                                                        width={5}
                                                    />
                                                </span>
                                                <DatePicker
                                                    className={style.datePickerInput}
                                                    format="DD MMM YYYY"
                                                    minDate={addBusinessDays(10)}
                                                    value={closingDateText}
                                                    onChange={(e) => {
                                                        if (e != undefined) {
                                                            methods.setValue("closingDate", e.format('DD/MM/YYYY'));
                                                            setClosingDateText(dayjs(e.format('DD/MM/YYYY')));
                                                            setClosingDateDisplayText(displayDateString(dayjs(e.format('DD/MM/YYYY'))));
                                                            setDisplayError(false);
                                                        }
                                                    }}
                                                    localeText={{
                                                        fieldMonthPlaceholder: (params) => (params.contentType === 'letter' ? 'MMM' : 'MM'),
                                                    }}
                                                />
                                            </div>
                                            {displayError &&
                                                <div className={clsx("flex flex-row pcaautocomplete mt-5", style.errorContainer)}>
                                                    <img src="assets/error-info-icon.svg" alt="error" />
                                                    <span className="text-sm ml-2 mt-1">
                                                        Please select a date on or after {dayjs(addBusinessDays(10)).format('LL')} (10 business days from today)
                                                    </span>
                                                </div>
                                            }
                                        </>
                                    }
                                    {application.applicationCategory != applicationCategory.Buy &&
                                        <>
                                            <div className="flex relative mt-2">
                                                <span>
                                                    <img
                                                        src="assets/error-icon.svg"
                                                        className={clsx(
                                                            methods.formState?.errors?.fundingDate?.message
                                                                ? ""
                                                                : "hidden",
                                                            "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[195px]"
                                                        )}
                                                        alt="error"
                                                        height={5}
                                                        width={5}
                                                    />
                                                </span>
                                                <DatePicker
                                                    className={style.datePickerInput}
                                                    format="DD MMM YYYY"
                                                    minDate={addBusinessDays(10)}
                                                    value={fundingDateText}
                                                    onChange={(e) => {
                                                        if (e != undefined) {
                                                            methods.setValue("fundingDate", e.format('DD/MM/YYYY'));
                                                            setFundingDateText(dayjs(e.format('DD/MM/YYYY')))
                                                            setFundingDateDisplayText(displayDateString(dayjs(e.format('DD/MM/YYYY'))));
                                                        }
                                                    }}
                                                    localeText={{
                                                        fieldMonthPlaceholder: (params) => (params.contentType === 'letter' ? 'MMM' : 'MM'),
                                                    }}
                                                />
                                            </div>
                                            {displayError &&
                                                <div className={clsx("flex flex-row pcaautocomplete mt-5", style.errorContainer)}>
                                                    <img src="assets/error-info-icon.svg" alt="error" />
                                                    <span className="text-sm ml-2 mt-1">
                                                        Please select a date on or after {dayjs(addBusinessDays(10)).format('LL')} (10 business days from today)
                                                    </span>
                                                </div>
                                            }
                                        </>
                                    }
                                </div>
                            </div>

                            {application.applicationCategory == applicationCategory.Buy &&
                                <div className="flex md:flex-row flex-col">
                                    <div className={style.twoColFirst}>
                                        <p className="mt-5 text-sm">Does your offer have a financing condition?</p>
                                        <div className="grid grid-flow-row sm:grid-flow-col mb-6">
                                            <ul className="grid grid-cols-3 gap-x-2 mt-2 max-w-md" style={{ maxWidth: "20rem" }}>
                                                <li className="relative">
                                                    <input
                                                        type="radio"
                                                        value="yes"
                                                        id="yes-financing-condition"
                                                        {...methods.register("financingConditionExists", {
                                                            onChange: financingConditionChangeHandler,
                                                        })}
                                                        checked={includeFinancingCondition === "yes"}
                                                        onChange={financingConditionChangeHandler}
                                                        className="sr-only peer "
                                                    />
                                                    <label
                                                        className={clsx(
                                                            style.phoneLabel,
                                                            "cursor-pointer focus:outline-none hover:bg-gray-100 peer-checked:ring-[--brand-blue] peer-checked:ring-2 peer-checked:border-transparent text-sm text-center",
                                                            methods.formState?.errors?.financingConditionExists?.message
                                                                ? style.labelError
                                                                : ""
                                                        )}
                                                        htmlFor="yes-financing-condition"
                                                    >
                                                        <p className="p-2 brand-blue-text leading-6" style={{ lineHeight: "1.5rem" }}>Yes</p>
                                                    </label>
                                                </li>
                                                <li className="relative">
                                                    <input
                                                        type="radio"
                                                        value="no"
                                                        id="no-financing-condition"
                                                        {...methods.register("financingConditionExists", {
                                                            onChange: financingConditionChangeHandler,
                                                        })}
                                                        checked={includeFinancingCondition === "no"}
                                                        onChange={financingConditionChangeHandler}
                                                        className="sr-only peer leading-6"
                                                    />
                                                    <label
                                                        className={clsx(
                                                            style.phoneLabel,
                                                            "cursor-pointer focus:outline-none hover:bg-gray-100 peer-checked:ring-[--brand-blue] peer-checked:ring-2 peer-checked:border-transparent text-sm text-center",
                                                            methods.formState?.errors?.financingConditionExists?.message
                                                                ? style.labelError
                                                                : ""
                                                        )}
                                                        htmlFor="no-financing-condition"
                                                    >
                                                        <p className="p-2 brand-blue-text leading-6" style={{ lineHeight: "1.5rem" }}>No</p>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {includeFinancingCondition === "yes" &&
                                        <div>
                                            <p className="mt-5 text-sm">Condition of Financing Date</p>
                                            <div className="flex relative mt-2">
                                                <span>
                                                    <img
                                                        src="assets/error-icon.svg"
                                                        className={clsx(
                                                            methods.formState?.errors?.financingConditionDate?.message
                                                                ? ""
                                                                : "hidden",
                                                            "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[195px]"
                                                        )}
                                                        alt="error"
                                                        height={5}
                                                        width={5}
                                                    />
                                                </span>
                                                <DatePicker
                                                    className={style.datePickerInput}
                                                    format="DD MMM YYYY"
                                                    minDate={addBusinessDays(10)}
                                                    value={financingConditionDateText}
                                                    onChange={(e) => {
                                                        if (e != undefined) {
                                                            methods.setValue("financingConditionDate", e.format('DD/MM/YYYY'));
                                                            setFinancingConditionDateText(dayjs(e.format('DD/MM/YYYY')));
                                                            setDisplayFinancingDateError(false);
                                                        }
                                                    }}
                                                    localeText={{
                                                        fieldMonthPlaceholder: (params) => (params.contentType === 'letter' ? 'MMM' : 'MM'),
                                                    }}
                                                />
                                            </div>
                                            {displayFinancingDateError &&
                                                <div className={clsx("flex flex-row pcaautocomplete mt-5", style.errorContainer)}>
                                                    <img src="assets/error-info-icon.svg" alt="error" />
                                                    <span className="text-sm ml-2 mt-1">
                                                        Please enter a valid financing condition date.
                                                    </span>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            <div className="flex max-sm:hidden">
                                <div className="mb-5">
                                    <button
                                        className="primary mt-5 w-169 sm:w-28 h-11 px-6"
                                        type="button"
                                        onClick={closeEdit}
                                    >
                                        Cancel
                                    </button>
                                </div>
                                <div className="mb-5">
                                    <button
                                        type="submit"
                                        className="primary mt-5 w-169 sm:w-28 h-11 px-6 mx-5"
                                        disabled={isSaving}
                                    >
                                        <FontAwesomeIcon icon={faSpinner} spin style={{ marginRight: 8 }} className={clsx(isSaving ? "" : "hidden")} />
                                        Save
                                    </button>
                                </div>
                            </div>
                            <div className="flex sm:hidden">
                                <div className="mb-5">
                                    <button
                                        className="primary mt-5 w-169 sm:w-28 h-11 px-6"
                                        type="button"
                                        onClick={closeEdit}
                                        style={{ minWidth: 90 }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                                <div className="mb-5">
                                    <button
                                        type="submit"
                                        className="primary mt-5 w-169 sm:w-28 h-11 px-6 mx-5"
                                        disabled={isSaving}
                                        style={{ minWidth: 90 }}
                                    >
                                        <FontAwesomeIcon icon={faSpinner} spin style={{ marginRight: 8 }} className={clsx(isSaving ? "" : "hidden")} />
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </motion.div>
                }
            </AnimatePresence>
        </div>
    );
}